import React, { useEffect, useState } from 'react';

const CHECK_GREEN_BG = 'rgba(0, 178, 164, 0.2)';
const MINUS_RED_BG = 'rgba(239, 68, 68, 0.2)';

function PerformerList({
  isMailing,
  setSelectApplicant,
  selectApplicant,
  isSelectApplicant,
  isApplicants,
  setOpenUser,
  name,
  form,
  currentItems,
  selectionVisual = 'checkbox',
  disableSelection = false,
  singleSelection = false,
}) {
  const userChecked = form.watch(name) || {};
  const [allChecked, setAllChecked] = useState(false);

  const isCustomSelectionVisual = !disableSelection && !isSelectApplicant && (selectionVisual === 'check-green' || selectionVisual === 'minus-red');

  const isAllChecked = (list, checkedMap) => {
    if (!list?.length) {
      return false;
    }
    return list.every((item) => Boolean(checkedMap[item.id]));
  };

  useEffect(() => {
    setAllChecked(isAllChecked(currentItems, userChecked));
  }, [currentItems, userChecked]);

  const updateRowSelection = (itemId, isChecked) => {
    if (singleSelection) {
      const nextChecked = isChecked ? { [itemId]: true } : {};
      form.setValue(name, nextChecked);
      setAllChecked(isAllChecked(currentItems, nextChecked));
      return;
    }

    const nextChecked = { ...userChecked };

    if (isChecked) {
      nextChecked[itemId] = true;
    } else {
      delete nextChecked[itemId];
    }

    form.setValue(name, nextChecked);
    setAllChecked(isAllChecked(currentItems, nextChecked));
  };

  const toggleAllSelection = (isChecked) => {
    if (singleSelection) {
      return;
    }

    if (isChecked) {
      let nextChecked = { ...userChecked };
      currentItems?.forEach((item) => {
        nextChecked = { ...nextChecked, [item.id]: true };
      });
      form.setValue(name, nextChecked);
      setAllChecked(true);
      return;
    }

    const nextChecked = { ...userChecked };
    currentItems?.forEach((item) => {
      delete nextChecked[item.id];
    });
    form.setValue(name, nextChecked);
    setAllChecked(false);
  };

  const getSelectedCellStyle = (isSelected) => {
    if (!isSelected) {
      return {};
    }

    if (isSelectApplicant || selectionVisual === 'check-green') {
      return { background: CHECK_GREEN_BG };
    }

    if (selectionVisual === 'minus-red') {
      return { background: MINUS_RED_BG };
    }

    return {};
  };

  return (
    <div className="flex w-full flex-col">
      <div className="overflow-y-auto">
        <div className="p-2 min-w-full inline-block align-middle">
          <div className="border rounded-lg overflow-hidden justify-start">
            <table className="items-center divide-y divide-gray-200 mb-20">
              <thead>
                <tr>
                  {!isMailing && !disableSelection && (
                    <th width={isSelectApplicant ? '50px' : '40px'} scope="col" className="py-3 text-start text-[16px] font-medium uppercase">
                      {isSelectApplicant || singleSelection ? (
                        <div></div>
                      ) : (
                        <input
                          id="select_all"
                          name="all"
                          type="checkbox"
                          aria-checked={false}
                          value={allChecked}
                          checked={allChecked}
                          className="h-4 w-4 rounded border-gray-300 text-blue-500 focus:ring-blue-500"
                          onChange={(e) => {
                            toggleAllSelection(e.target.checked);
                          }}
                        />
                      )}
                    </th>
                  )}

                  <th width="40px" scope="col" className="py-3 text-start text-[16px] font-medium uppercase">
                    №
                  </th>
                  <th scope="col" className="py-3 text-start text-[16px] font-medium uppercase">
                    ФИО
                  </th>
                  {isApplicants && (
                    <th width="auto" scope="col" className="px-8 py-3 text-start text-[16px] font-medium">
                      Статус
                    </th>
                  )}
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200 items-center justify-center align-middle">
                {currentItems &&
                  currentItems?.map((item) => {
                    const isSingleSelected = selectApplicant == item.id;
                    const isChecked = Boolean(userChecked[item.id]);
                    const isRowSelected = isSelectApplicant ? isSingleSelected : isCustomSelectionVisual && isChecked;
                    const selectedCellStyle = getSelectedCellStyle(isRowSelected);
                    const fullName = item.full_name || item.name || '-';

                    return (
                      <tr
                        key={item.id}
                        onClick={() => {
                          if (disableSelection) {
                            return;
                          }
                          if (isSelectApplicant) {
                            setSelectApplicant(item.id);
                          }

                          if (isCustomSelectionVisual) {
                            updateRowSelection(item.id, !isChecked);
                          }
                        }}
                        style={isSelectApplicant || isCustomSelectionVisual ? { cursor: 'pointer' } : {}}>
                        {!isMailing && !disableSelection && (
                          <td className="py-4 whitespace-nowrap text-sm text-gray-800" style={selectedCellStyle}>
                            {isSelectApplicant ? (
                              <div>
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" className="text-gray-400 ml-3">
                                  <path fill={isSingleSelected ? 'rgb(0, 178, 164)' : 'rgba(156, 163, 175,0.6)'} d="m9.55 15.15l8.475-8.475q.3-.3.7-.3t.7.3t.3.713t-.3.712l-9.175 9.2q-.3.3-.7.3t-.7-.3L4.55 13q-.3-.3-.288-.712t.313-.713t.713-.3t.712.3z" />
                                </svg>
                              </div>
                            ) : isCustomSelectionVisual ? (
                              <div className="ml-2">
                                {selectionVisual === 'check-green' ? (
                                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                                    <path fill={isChecked ? 'rgb(0, 178, 164)' : 'rgba(156, 163, 175,0.8)'} d="m9.55 15.15l8.475-8.475q.3-.3.7-.3t.7.3t.3.713t-.3.712l-9.175 9.2q-.3.3-.7.3t-.7-.3L4.55 13q-.3-.3-.288-.712t.313-.713t.713-.3t.712.3z" />
                                  </svg>
                                ) : (
                                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                                    <path fill={isChecked ? 'rgb(239, 68, 68)' : 'rgba(156, 163, 175,0.8)'} d="M7 11v2h10v-2z" />
                                  </svg>
                                )}
                              </div>
                            ) : (
                              <input
                                name={item.num}
                                type="checkbox"
                                aria-checked={'false'}
                                onClick={() => {}}
                                className="select_checkbox h-4 w-4 rounded border-gray-300 text-blue-500 focus:ring-blue-500"
                                defaultChecked={userChecked[item.id]}
                                checked={isChecked}
                                onChange={(e) => {
                                  updateRowSelection(item.id, e.target.checked);
                                }}
                              />
                            )}
                          </td>
                        )}

                        <td className="py-4 whitespace-nowrap text-sm text-gray-800" style={selectedCellStyle}>
                          {item.id}
                        </td>
                        <td className="py-4 whitespace-nowrap text-sm text-gray-800" style={selectedCellStyle}>
                          <div
                            style={{ cursor: 'pointer', display: 'inline-block' }}
                            onClick={(e) => {
                              e.stopPropagation();
                              setOpenUser(item.id);
                            }}>
                            {fullName}
                          </div>
                        </td>
                        {isApplicants && (
                          <td className="px-8 py-4 whitespace-nowrap text-sm text-gray-800" style={selectedCellStyle}>
                            {item?.is_active && !item?.is_blocked ? 'Активен' : !item?.is_active && !item?.is_blocked ? 'Не активен' : !item?.is_active && item?.is_blocked ? 'Заблокирован' : ''}
                          </td>
                        )}
                      </tr>
                    );
                  })}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PerformerList;
